import { call, delay, put, select, takeEvery } from 'redux-saga/effects';
import * as documentCardActions from '../actions/documentCard';
import { errorProcessing } from '../../../../Employees/api/errorProcessing';
import { getDocumentById } from '../../api/documentCard/getDocumentById';
import history from '../../../../../common/history';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getDocumentByIdSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getDocumentById,
        action.payload,
        activeProfileId
      );
      let documentTypes = {};
      let documentsStat = {};

      response.data.documents.forEach(item => {
        if (item.status.statusKeyGroup) {
          const { statusKeyGroup } = item.status;
          if (!documentTypes.hasOwnProperty(statusKeyGroup)) {
            documentTypes[statusKeyGroup] = {
              key: statusKeyGroup,
              status: item.status.status,
            };
          }
          documentsStat.hasOwnProperty(statusKeyGroup)
            ? documentsStat[statusKeyGroup]++
            : (documentsStat[statusKeyGroup] = 1);
        }
      });
      yield put(
        documentCardActions.getOrderForDocumentsByIdSuccess({
          documentTypes: Object.keys(documentTypes).map(
            key => documentTypes[key]
          ),
          response,
          documentsStat,
        })
      );
    } catch (e) {
      yield put(
        documentCardActions.getOrderForDocumentsByIdFailure(errorProcessing(e))
      );
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(documentCardActions.getOrderForDocumentsById(action.payload))
      : history.push('/authorization/profiles');
  }
}

export function* documentCardConfigWatcher() {
  yield takeEvery(
    documentCardActions.getOrderForDocumentsById.toString(),
    getDocumentByIdSaga
  );
}
